import React from 'react';
import { useSelector } from 'react-redux';

import ResponsiveToggleGroup from 'src/component/UI/ResponsiveToggleGroup';
import { useTranslation } from 'src/i18n/useTranslation';

import { getUnits } from 'src/module/filter/selector';

export default function UnitSelector () {
  const units = useSelector(getUnits);
  const { t } = useTranslation();

  return (
    <div data-testid='unit-selector'>
      <ResponsiveToggleGroup
        buttons={units}
        mainLabel={t('common.all')} />
    </div>
  );
}

UnitSelector.propTypes = {
};

UnitSelector.defaultProps = {
};
